/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'cloudStorage' implicitly has an 'any' t... Remove this comment to see the full error message
const CloudStorageSignOutLink = (cloudStorage, alerts, i18n, viewStateService) => ({
   replace: true,
   templateUrl: '/assets/cloudStorage/signOutLink.html',

   link(scope: any, el: any, attrs: any) {
      scope.cloudStorage = cloudStorage.scope
      scope.viewState = viewStateService
      scope.iconClass = () => 'icons-' + scope.cloudStorage.signedInProvider().name.toLowerCase() + '-icon-sm'
      return scope.signOut = function() {
         const provider = scope.cloudStorage.signedInProvider()
         return cloudStorage.signOut(provider.name.toLowerCase()).then(() => alerts.pulseAlert('cloudStorageSignOut', i18n.translate(i18n.translations.SIGN_OUT_FROM_X_CONFIRM, {x: provider.name}), 5000))
      }
   }
})

const SignInButton = (cloudStorage: CloudStorageService, alerts: AlertService, i18n: TranslationService, authService: AuthenticationService) => ({
   replace: true,
   templateUrl: '/assets/cloudStorage/signInButton.html',
   controller: 'SavedSearchCtrl',

   scope: {
      signInFunction: '&',
      currentProvider: '=',
      authFeature: '@'
   }, 

   link(scope: any) {
      scope.i18n = i18n
      scope.provider = scope.currentProvider
      scope.openLoginDialog = () => {
         authService.openLoginDialog('cloudStorage')
      }
      return scope.signIn = () => {
         // unless auth feature is cloud storage, use sign in function to sign in
         if(scope.authFeature !== 'cloudStorage') {  
            return scope.signInFunction()
         }
         // if not, means it is a cloudStorage sign in
         return cloudStorage.signIn(scope.provider.name)
      }
   }
})

const ChooseProviderSignIn = (cloudStorage: CloudStorageService, i18n:TranslationService) => ({
   replace: true,
   templateUrl: '/assets/cloudStorage/chooseProviderSignIn.html',
   scope: {
      allProviders: '='
   },

   link(scope: any) {
      scope.i18n = i18n
      return scope.providers = scope.allProviders? scope.allProviders : cloudStorage.scope.providers
   }
})

const cloudStorageSignedIn = (cloudStorage: CloudStorageService, i18n: TranslationService) => ({
   replace: true,
   templateUrl: '/assets/cloudStorage/cloudStorageSignedIn.html',
   scope: {
      helpLinkKey: '@' // Use '@' for one-way binding
   },
   link(scope: any) {
      scope.i18n = i18n
      scope.providers = cloudStorage.scope.providers
      scope.isSignedIn = cloudStorage.isSignedIn
      scope.signedInProvider = cloudStorage.signedInProvider
   }
})

angular.module('summonApp.directives')
   .directive('cloudStorageSignOutLink', ['cloudStorageService', 'alertService', 'translationService', 'viewStateService', CloudStorageSignOutLink])
   .directive('signInButton', ['cloudStorageService', 'alertService', 'translationService', 'authenticationService', SignInButton])
   .directive('chooseProviderSignIn', ['cloudStorageService', 'translationService', ChooseProviderSignIn])
   .directive('cloudStorageSignedIn', ['cloudStorageService', 'translationService', cloudStorageSignedIn])

